import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import useGuardianFeesService, {
  GuardianFee,
} from '../../../../apis/guardian/sub-apis/useGuardianFeesService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;

export const getGuardianFeesKey = 'get-guardian-fees';

export const useGuardianFeesHook = (
  studentId: string,
  params: TPaginationParams & { status?: string; academicYear?: string },
  options?: UseQueryOptions<{ data: GuardianFee[]; count: number }, TQueryError>
): UseQueryResult<{ data: GuardianFee[]; count: number }, TQueryError> => {
  const { getFees } = useGuardianFeesService();

  const safeParams = { ...params, page: params.page ?? 1, limit: params.limit ?? 10 };
  return useQuery<{ data: GuardianFee[]; count: number }, TQueryError>({
    queryKey: [getGuardianFeesKey, studentId, safeParams],
    queryFn: () => getFees(studentId, safeParams),
    enabled: !!studentId,
    ...options,
  });
};

export const useGuardianPayFeeHook = () => {
  const { payFee } = useGuardianFeesService();
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; message: string },
    TQueryError,
    { studentId: string; feeId: string; paymentData: { amount: number; paymentMethod: string; transactionId?: string; transactionDateTime?: string } }
  >({
    mutationFn: ({ studentId, feeId, paymentData }) => payFee(studentId, feeId, paymentData),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [getGuardianFeesKey, variables.studentId] });
    },
  });
};
